import { render, staticRenderFns } from "./AssessmentsListingHead.vue?vue&type=template&id=0f09cf76&scoped=true"
import script from "./AssessmentsListingHead.vue?vue&type=script&lang=ts"
export * from "./AssessmentsListingHead.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentsListingHead.vue?vue&type=style&index=0&id=0f09cf76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f09cf76",
  null
  
)

export default component.exports